//#region lib/utils/text.ts
function e(e) {
	return e.replaceAll(/([a-z])([A-Z])/g, "$1 $2").toLowerCase().replaceAll("_", " ").replaceAll("-", " ").replaceAll(/\b\w/g, (e) => e.toUpperCase()).trim();
}
//#endregion
export { e as titleCase };
